import { Validators } from '@angular/forms';
import {
  FormFieldList,
  SfAmountInputFormField,
  SfDatePickerFormField,
  SfInputFormField,
  SfNumberInputFormField,
  SfSelectFormField,
  SfSelectOption,
  SfTextAreaFormField,
  SfUtils,
} from 'ngx-smart-form';
import { FormField } from 'ngx-smart-form/lib/smart-form/classes/form-field';
import { CfFormField } from '../anagraphics/add-subject-dialog/cf-form-field';
import { Impresa } from './models/impresa';
import { COUNTRIES } from '../../assets/aml-config/countries';
import { PraticaType } from '../../interfaces/pratica';
import { getModalitaIdentificazioneOptions } from './models/modalita-identificazione.enum';

export const getApplicantFields = (
  praticaType: PraticaType,
  applicant?: Impresa,
  isFiduciaria = false
) => {
  let required = praticaType === 'FIN' ? true : false;
  let fields: FormFieldList<Impresa> = [
    [
      new SfInputFormField<Impresa>({
        formControlName: 'denominazione',
        label: 'Denominazione/Ragione sociale',
        required: true,
      }),
      new SfInputFormField<Impresa>({
        formControlName: 'partitaIva',
        label: 'Partita IVA',
        required: true,
        validators: [
          Validators.minLength(11),
          Validators.pattern(
            '^[0-9]{11}$|^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$'
          ),
        ],
      }),
    ],
    [
      new SfDatePickerFormField<Impresa>({
        formControlName: 'dataCostituzione',
        label: 'Data di costituzione',
        required,
        value: new Date(applicant?.dataCostituzione || ''),
      }),
      new SfDatePickerFormField<Impresa>({
        formControlName: 'dataInizioAttivita',
        label: 'Data inizio attività',
        required,
        value: new Date(applicant?.dataInizioAttivita || ''),
      }),
    ],
    [
      new CfFormField<Impresa>({
        required,
      }),
      new SfInputFormField<Impresa>({
        formControlName: 'rae',
        label: 'RAE',
        required,
      }),
    ],
    [
      new SfInputFormField<Impresa>({
        formControlName: 'rea',
        label: 'Codice REA',
        required,
      }),
      new SfInputFormField<Impresa>({
        formControlName: 'provinciaRea',
        label: 'Provincia REA',
        required,
      }),
    ],
    [
      new SfInputFormField<Impresa>({
        formControlName: 'sae',
        label: 'SAE',
        required: true,
      }),
      new SfSelectFormField({
        formControlName: 'indiciReputazionaliNegativi',
        label: 'Indici reputazionali negativi',
        required: true,
        options: [
          { value: 'CONDANNE', view: 'Condanne' },
          { value: 'PROCEDIMENTI', view: 'Procedimenti' },
          { value: 'NO', view: 'No' },
        ],
      }),
    ],

    [
      new SfInputFormField<Impresa>({
        formControlName: 'pec',
        label: 'PEC',
        required,
        validators: [Validators.email],
      }),
      new SfInputFormField<Impresa>({
        formControlName: 'pecAggiuntiva',
        label: 'PEC aggiuntiva',
        validators: [Validators.email],
      }),
    ],
    [
      new SfInputFormField<Impresa>({
        formControlName: 'ateco',
        label: 'ATECO 2007',
        required,
      }),
      new SfInputFormField<Impresa>({
        formControlName: 'email',
        label: 'Email',
        required,
        validators: [Validators.email],
      }),
    ],
    [
      new SfInputFormField<Impresa>({
        formControlName: 'prefisso',
        label: 'Prefisso',
      }),
      new SfInputFormField<Impresa>({
        formControlName: 'telefono',
        label: 'Telefono',
        validators: [
          //Validators.minLength(7),
          Validators.maxLength(10),
          Validators.pattern('^[0-9]*$'),
        ],
      }),
    ],
    [
      new SfInputFormField<Impresa>({
        formControlName: 'iban',
        label: 'Iban',
        validators: [
          Validators.pattern('IT[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}'),
        ],
      }),
      new SfInputFormField<Impresa>({
        formControlName: 'intestatarioIban',
        label: 'Intestatario iban',
      }),
    ],
    [
      new SfNumberInputFormField<Impresa>({
        formControlName: 'numeroDipendenti',
        label: 'Numero dipendenti',
        required,
        validators: [Validators.min(0)],
      }),
      new SfAmountInputFormField<Impresa>({
        formControlName: 'fatturatoUltimoAnno',
        label: 'Fatturato ultimo anno',
        required,
        currency: '€',
      }),
    ],
    [
      new SfInputFormField<Impresa>({
        formControlName: 'oggettoSociale',
        label: 'Oggetto sociale',
        required,
      }),
      new SfInputFormField<Impresa>({
        formControlName: 'notizieDaStatuto',
        label: 'Notizie da statuto',
        required,
      }),
    ],
    [
      new SfTextAreaFormField<Impresa>({
        formControlName: 'attivita',
        label: 'Attività esercitata nella sede',
        required: true,
      }),
      new SfTextAreaFormField<Impresa>({
        formControlName: 'attivitaSecondaria',
        label: 'Attività secondaria esercitata nella sede',
        required,
      }),
    ],
    [
      new SfInputFormField<Impresa>({
        formControlName: 'codiceNace',
        label: 'Codice nace',
        required,
      }),
      new SfSelectFormField<Impresa>({
        formControlName: 'presenzaListeAntiterrorismo',
        label: 'Presenza liste antiterrorismo',
        required: true,
        options: [
          { value: true, view: 'SI' },
          { value: false, view: 'NO' },
        ] as SfSelectOption<any>[],
      }),
    ],
  ];

  if (praticaType === 'AML' && !isFiduciaria) {
    fields.push([
      new SfSelectFormField({
        formControlName: 'modalitaIdentificazione',
        label: 'Modalità di identificazione',
        required: true,
        options: getModalitaIdentificazioneOptions(),
      }),
    ]);
  }

  fields.forEach((row) =>
    row.forEach(
      (field) =>
        (field.value =
          field.value !== undefined
            ? field instanceof SfDatePickerFormField
              ? new Date(field.value)
              : field.value
            : field instanceof SfDatePickerFormField
            ? new Date(applicant?.[field.formControlName])
            : applicant?.[field.formControlName])
    )
  );
  return fields;
};
